import { useMemo, useState } from 'react';
import confettiIMG from '@/assets/imgs//misc/confetti.svg';
import brandDarkIMG from '@/assets/imgs/brand/logo.png';
import login1Illustration from '@/assets/imgs/login//card1.png';
import {
  Button,
  Checkbox,
  Error,
  Image,
  LoadingStatus,
  Modal,
  Spinner,
  ThemeButton,
} from '@/components/generic';
import { cn } from '@/lib/utils';
import {
  useConnectAccount,
  // useDisconnectAccount,
  useRegister,
} from '@package/smart-wallet/hooks';
import { Link, useNavigate } from 'react-router-dom';

export const Home = () => {
  const [isChecked, setIsChecked] = useState(false);
  const navigate = useNavigate();

  /* Hooks */
  const {
    isLoading: isLoadingConnect,
    isConnected,
    handleConnect,
  } = useConnectAccount();
  // const { isLoading: isLoadingDisconnect, handleDisconnect } =
  //   useDisconnectAccount({
  //     onSuccess: () => {
  //       navigate('/');
  //     },
  //   });
  const {
    isLoading: isLoadingRegister,
    error: errorRegister,
    showEmailExistsModal,
    handleCloseEmailExistsModal,
  } = useRegister({
    isConnected,
    onSuccess: () => {
      navigate('/dashboard');
    },
  });

  /* Memo */
  const isLoading = useMemo(() => {
    return isLoadingConnect || isLoadingRegister;
  }, [isLoadingConnect, isLoadingRegister]);
  return (
    <>
      <Modal open={isLoading} onClose={() => {}} noShowButtonClose>
        <LoadingStatus />
      </Modal>
      <div className='relative flex min-h-svh p-2 bg-b-surface1 max-lg:pt-24 max-lg:pb-12 max-md:px-6 max-md:pt-20 max-md:pb-8 font-inter transition-all duration-300 '>
        {/* {isConnected && (
          <button
            type='button'
            disabled={isLoadingDisconnect || !isConnected}
            onClick={handleDisconnect}
            className='text-t-primary absolute top-12 right-12 text-sub-title-1 hover:opacity-55 transition-all hover:underline text-theme-secondary max-2xl:top-10 max-2xl:right-10 max-xl:top-6 max-xl:right-6 max-lg:top-12 max-lg:right-12 max-md:top-8 max-md:right-6'
          >
            Not your account?&nbsp;
          </button>
        )} */}

        <div className='relative w-[600px] bg-b-surface2 rounded-[32px] overflow-hidden max-2xl:w-[30rem] max-xl:w-[24.375rem] max-lg:hidden'>
          <Image
            className='w-full h-full [&>*]:!object-left [&>*]:!object-cover'
            src={login1Illustration}
            alt=''
          />
        </div>
        <div className='flex grow justify-center items-center px-12 py-14 max-lg:p-0'>
          <div className='max-w-[32.5rem] w-full 2xl:max-w-[24rem]'>
            <div className='mb-10 max-2xl:mb-8 text-t-primary'>
              <Link
                className='absolute w-10 top-10 left-10 z-2 max-2xl:top-8 max-2xl:right-8 max-lg:top-10 max-lg:right-10 max-md:static max-md:inline-block max-md:mb-5'
                to='/'
              >
                <Image className='w-10' src={brandDarkIMG} alt='' />
              </Link>
              <ThemeButton className='fixed left-5 bottom-5 z-10 max-lg:hidden ' />
              <div className='relative text-h4 leading-tight '>
                Spend Your Crypto Anywhere With Full Control and Zero Friction
                <div className='absolute -top-12 right-4.5 pointer-events-none max-md:hidden'>
                  <Image src={confettiIMG} alt='' />
                </div>
              </div>
              <div className='mt-5 text-sub-title-2 font-light text-theme-tertiary max-md:mt-4 max-md:text-caption leading-tight'>
                Create your wallet in minutes and start using your crypto freely
                — no delays, no restrictions, no middlemen.
              </div>
            </div>

            <form
              className='flex flex-col  mb-8 pb-8 space-x-2'
              onSubmit={(e) => {
                e.preventDefault();
                handleConnect();
              }}
            >
              <Checkbox
                className='mb-4'
                label='By signing up, you agree to the Terms of Use, Privacy Notice, and Cookie Notice.'
                checked={isChecked}
                onChange={(value) => setIsChecked(value)}
                required
                disabled={isLoading || isConnected}
                name='terms'
                id='terms'
                value='terms'
              />
              <div className='mb-5 text-caption text-t-tertiary font-light '>
                Trusted by over 25,000 crypto users worldwide
              </div>
              {isConnected ? (
                <Button
                  type='submit'
                  className={cn('w-full !py-6 cursor-pointer')}
                  isBlack
                  as={'link'}
                  href='/dashboard'
                >
                  Go To Dashboard
                </Button>
              ) : (
                <Button
                  type='submit'
                  className={cn(
                    'w-full !py-6 cursor-pointer',
                    isLoading && 'cursor-not-allowed',
                    isConnected && 'cursor-not-allowed ',
                    isChecked && '!cursor-not-allowed',
                  )}
                  isBlack={isChecked}
                  isWhite={!isChecked}
                  disabled={!isChecked || isLoading || isConnected}
                >
                  {isLoading ? (
                    <Spinner className='!bg-transparent' />
                  ) : (
                    'Get Started'
                  )}
                </Button>
              )}
            </form>
            <Error
              error={errorRegister}
              message={errorRegister || 'Error While trying to login'}
              className='mb-1'
            />
            <div className='mb-5 text-caption text-t-primary font-light '>
              Your keys. Your wallet. Your freedom.
            </div>

            {/* //// */}
          </div>
        </div>
      </div>

      <Modal open={showEmailExistsModal} onClose={handleCloseEmailExistsModal}>
        <div className='flex flex-col items-center gap-6 text-center'>
          <div className='text-2xl font-bold text-t-primary'>
            Email Already Has a Wallet
          </div>
          <div className='text-base text-t-secondary'>
            This email address already has an associated wallet. Please use a
            different email or contact support if you believe this is an error.
          </div>
          <Button
            className='w-full !py-3 cursor-pointer'
            onClick={handleCloseEmailExistsModal}
            isBlack
          >
            OK
          </Button>
        </div>
      </Modal>
    </>
  );
};
